import { BaseDevice, CustomLayout } from '../base_device'
import list_icon from '@/assets/img/device/mt87/list_icon.png'
import { getDeviceKeySquare } from './keysquare/keysquare'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST_V1 } from '../light/light_effect_list'

export class Mt87 extends BaseDevice {
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST_V1
  private y_number: number = 7
  square = getDeviceKeySquare(DevicePid.IYXMt87)
  name: string = 'MT87'
  icon: string = list_icon
  width: number = 708

  fnDisableKeys: KK[] = [0, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 7, 13, 19, 56, 62, 85, 86, 92]

  inoperableKeys: KK[] = [0x3b]
  customLayout: CustomLayout = {
    0xc: this.createSquare(40.5, 2),
    0x24: this.createSquare(20.6, 2),
    0x3c: this.createSquare(20.6, 2),
    0x54: this.createSquare(9, 2),
    0x1: this.createSquare(2, this.y_number),
    0x7: this.createSquare(2, this.y_number),
    0xd: this.createSquare(2, this.y_number),
    0x13: this.createSquare(2, this.y_number),
    0x19: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x2b: this.createSquare(2, this.y_number),
    0x31: this.createSquare(2, this.y_number),
    0x37: this.createSquare(2, this.y_number),
    0x3d: this.createSquare(2, this.y_number),
    0x43: this.createSquare(2, this.y_number),
    0x49: this.createSquare(2, this.y_number),
    0x4f: this.createSquare(2, this.y_number, 73),
    0x55: this.createSquare(9, this.y_number),
    0x5b: this.createSquare(2, this.y_number),
    0x61: this.createSquare(2, this.y_number),
    0x2: this.createSquare(2, 2, 54.8),
    0x50: this.createSquare(2, 2, 54.8),
    0x56: this.createSquare(9, 2),
    0x3: this.createSquare(2, 2, 67.5),
    0x51: this.createSquare(2, 2, 80.3),
    0x4: this.createSquare(2, 2, 87.6),
    0x52: this.createSquare(2, 2, 98.6),
    0x5e: this.createSquare(48, 2),
    0x5: this.createSquare(2, 2, 47.5),
    0xb: this.createSquare(2, 2, 47.5),
    0x11: this.createSquare(2, 2, 47.5),
    0x23: this.createSquare(2, 2, 237),
    0x35: this.createSquare(2, 2, 47.5),
    0x41: this.createSquare(2, 2, 47.5),
    0x53: this.createSquare(2, 2, 47.5),
    0x59: this.createSquare(10, 2),
  }
}
